export default "https://housescan.app.solease.nl/static/media/floor_insulation.a6c7ac56.svg";